import axios from 'axios';
import { API_CONFIG, ENDPOINTS } from '../config/endpoints.js';
import { tokenService } from './tokenService.js';

const api = axios.create({
  baseURL: API_CONFIG.BASE_URL || '',
  timeout: API_CONFIG.TIMEOUT || 30000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'Accept': 'application/json',
  },
});

// Interceptor para adicionar o token JWT
api.interceptors.request.use(
  (config) => {
    try {
      const token = tokenService.getToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = token;
      }
    } catch (e) {
      // ignore
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de resposta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      tokenService.clearAll();
      // Avoid redirecting to root for login attempts — let the caller handle errors
      const requestUrl = error?.config?.url || '';
      const isLoginRequest = requestUrl === ENDPOINTS.ADMIN_LOGIN;
      if (!isLoginRequest) {
        try { window.location.href = '/'; } catch (e) {}
      }
    }
    return Promise.reject(error);
  }
);

export { api };
export { API_CONFIG } from '../config/endpoints.js';
